import React, { useEffect, useState } from 'react';

import { useInvestorAppDataQuery, useInvestorWalletQuery, useRefreshInvestorBalanceMutation } from 'services/apollo';
import { useActiveSto } from 'hooks';

import { Loading } from 'atoms';
import WalletManagement from 'pages/wallet/components/WalletManagement';
import DepositHistory from 'pages/wallet/components/DepositHistory';

const Wallet: React.FC = () => {
  const { sto } = useActiveSto();
  const [selectedSto, setSto] = useState(sto);
  const { data, loading } = useInvestorWalletQuery({
    variables: { _id: Number(selectedSto) },
    fetchPolicy: 'no-cache',
  });
  const [updateExternalBalance] = useRefreshInvestorBalanceMutation();
  const [extBal, setExtBal] = useState(0);
  const handleUpdateExternalBalance = async () => {
    const bal = await updateExternalBalance();
    setExtBal(bal.data?.refreshInvestorBalance || 0);
  };
  useEffect(() => {
    handleUpdateExternalBalance();
  }, []);

  const { data: data1, loading: loading1 } = useInvestorAppDataQuery({ fetchPolicy: 'no-cache' });
  if (loading || !data || loading1 || !data1) {
    return <Loading />;
  }

  const { investorBalances: accounts, investorPaymentChannels: channels, investorDepositHistory: history } = data;

  const { investorAppParameters } = data1;
  const { isInvestorDashboardSwitchEnabled } = investorAppParameters;

  const displayPropertyName = !isInvestorDashboardSwitchEnabled || Number(selectedSto) < 0;

  return (
    <div className="content">
      <WalletManagement
        accounts={accounts}
        channels={channels}
        sto={Number(selectedSto)}
        setSto={(value) => setSto(Number(value))}
        externalBalance={extBal}
        appData={investorAppParameters}
      />
      <DepositHistory history={history} displayPropertyName={displayPropertyName} />
    </div>
  );
};

export default Wallet;
